import React, { PureComponent, Fragment } from 'react';
import Radium from 'radium';
import { string, bool, shape } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { formValueSelector } from 'redux-form';
import { UTLabel } from '@widergy/energy-ui';

import { gaTrackPageView } from 'services/AnalyticsService';
import UTBanner from 'app/components/UTBanner';
import BillActions from 'redux/bill/actions';
import { message } from 'utils/stringUtils';
import Images from 'config/assets';
import { ROUTES } from 'constants/routes';
import { LAST_BILL_QUERY } from 'constants/reduxForms';
import { appConfig } from 'config/customization';

import LastBillQuery from './layout';
import styles from './styles';

const DOCUMENT_TYPE = 'document_type';

class LastBillQueryContainer extends PureComponent {
  componentDidMount() {
    gaTrackPageView(ROUTES.PUBLIC_LAST_BILL_QUERY);
  }

  componentWillUnmount = () => this.props.dispatch(BillActions.resetLastBillInformation());

  onSubmit = values =>
    this.props.dispatch(BillActions.getLastBillInformation(values.clientNumber, values.email));

  handleBackToHome = () => {
    const route = appConfig.publicDashboard.home ? ROUTES.PUBLIC_HOME : ROUTES.PUBLIC_PAYMENTS;
    this.props.dispatch(push(route));
  };

  handleGoToSignUp = () => this.props.dispatch(push(ROUTES.SIGN_UP));

  render() {
    return (
      <Fragment>
        <div style={styles.container}>
          <UTLabel large bold>
            {message('PublicLastBill:lastBillTitle')}
          </UTLabel>
          <div style={[this.props.loading && styles.withLoading]}>
            <LastBillQuery
              documentType={this.props.documentType}
              onSubmit={this.onSubmit}
              lastBillInformation={this.props.lastBillInformation}
              loading={this.props.loading}
              onGoToHome={this.handleBackToHome}
            />
          </div>
        </div>
        <UTBanner
          loading={this.props.loading}
          imageUrl={Images.bannerSignup}
          containerStyle={styles.bannerContainer}
          customBanner
          onBannerClick={this.handleGoToSignUp}
        />
      </Fragment>
    );
  }
}

LastBillQueryContainer.propTypes = {
  loading: bool,
  lastBillInformation: shape({
    amount: string.isRequired,
    due_date: string.isRequired,
    message: string.isRequired
  }),
  documentType: string
};

const formSelector = formValueSelector(LAST_BILL_QUERY);

const mapStateToProps = store => ({
  lastBillInformation: store.bill.lastBillInformation,
  loading: store.bill.lastBillInformationLoading,
  documentType: formSelector(store, DOCUMENT_TYPE)
});

export default connect(mapStateToProps)(Radium(LastBillQueryContainer));
